import {
  PlaceholderTiles,
  RowSection,
  SkeletonBlock,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const RecommendationsSkeleton = () => {
  return (
    <RowSection>
      <HeaderWrapper>
        <StyledHeaderSkeleton $width="120px" $height="25px" />
      </HeaderWrapper>
      <Wrapper>
        <PlaceholderTiles amount={3} ctaVisible />
      </Wrapper>
      <HeaderWrapper>
        <StyledHeaderSkeleton $width="120px" $height="25px" disableSpaceBelow />
      </HeaderWrapper>
      <Wrapper>
        <PlaceholderTiles amount={3} ctaVisible />
      </Wrapper>
    </RowSection>
  );
};

const HeaderWrapper = styled.div`
  padding: 24px 16px;
`;

const StyledHeaderSkeleton = styled(SkeletonBlock)`
  margin-bottom: 28px;
`;

const Wrapper = styled.div`
  display: flex;
  gap: 5px;
  padding: 0 0 0 16px;
`;
